module.exports = __webpack_public_path__ + "static/WEDDING E&M-487-b0ec6df689529ae2dee3b26e6523eb33.jpg";